import gql from 'graphql-tag';

export const fragments = {};

export const CURRENT_TIME_QUERY = gql`
  query CurrentTimeQuery {
    currentTime
  }
`;
